import VForm from '@/vuetify_custom/v-form'
 import { commonValidateRule } from './utils'
import {common_mixins} from './EditMixIns.jsx'
 const commonValidateRuleGo = commonValidateRule('必选')
export default {
    mixins:[common_mixins],
    props: {
        defaultApply: {
            type: Array,
        }
    },
    computed: {
        fields() {
            const _this = this
            return [
                {
                    label: '填表时间',
                    key:'zhibiao_date',
                    cols: 2,
                    disabled: true,
                },
                {
                    label: '申请人',
                    key:'apply_user_id',
                    initList: this.defaultApply,
                    type:'autocompletes_async_v1',
                    'item-value':'id',
                    'item-text':'account',
                    api: this.$util.api.customer_select_search,
                    init_list: [], // this.apply_user_list,
                    cols: 2,
                    required: true,
                    out_params: {
                     //    formal: true,
                    },
                    rules: [commonValidateRuleGo],
                    handle_data:({customers}) => {
                     return customers
                    },
                    change:(data, target = {}) => {
                        _this.params.apply_user = target.account
                    }
                },
                {
                    label: '制单人',
                    key:'fill_user',
                    cols: 2,
                    disabled: true,
                },
                {
                    label: '单据编号',
                    type: 'text_field',
                    key: 'uid',
                    cols: 2,
                    disabled: true,
                  },
                  {
                    label: '填写类型',
                    type: 'radio_buttons',
                    key: 'is_jianyi',
                    cols: 4,
                    row: true,
                    disabled: !_this.params.can_change_jy,
                    items: [
                        {
                            value: true,
                            key: true,
                            label: '简易',
                        },
                        {
                            value: false,
                            key: false,
                            label: '完整',
                        }
                    ]
                  }
            ]
        }
    },
    render() {
        const _this = this
        return <VForm
            ref="base"
            fields={_this.fields}
            v-model={_this.params}
        />
    }
}